import { motion } from "framer-motion";
import { FaCogs, FaLayerGroup, FaTools } from "react-icons/fa";

export default function EngineeredForExcellence() {
  const features = [
    {
      icon: <FaCogs size={42} className="text-[#d62828]" />,
      title: "Precision Built",
      desc: "Our glove boxes deliver consistently stable inert environments.",
    },
    {
      icon: <FaLayerGroup size={42} className="text-[#d62828]" />,
      title: "Layered Protection",
      desc: "Multi-stage purification systems ensure extreme purity.",
    },
    {
      icon: <FaTools size={42} className="text-[#d62828]" />,
      title: "Built for Industry",
      desc: "Designed to meet demanding research and manufacturing needs.",
    },
  ];

  return (
    <section className="w-full py-20 px-6 bg-[#f7f7f7] border-t border-b border-gray-200">
      <div className="max-w-6xl mx-auto text-center">
        
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-3xl md:text-4xl font-bold text-[#222] mb-6 tracking-tight"
        >
          Engineered for Excellence
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-10 mt-10">
          {features.map((i, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 40 }}
              animate={{ opacity: 1, y: 0 }}
              whileHover={{
                scale: 1.05,
                boxShadow: "0 0 20px rgba(0,0,0,0.15)",
                borderColor: "#d62828",
              }}
              className="bg-white p-10 rounded-xl border border-gray-300 transition-all duration-200"
            >
              <div className="flex justify-center mb-5">{i.icon}</div>
              <h3 className="text-xl font-semibold text-[#222] mb-2">
                {i.title}
              </h3>
              <p className="text-gray-600">{i.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
